import { connect } from 'react-redux'
import { ThunkDispatch } from 'redux-thunk'
import { AnyAction } from 'redux'

import { IChangedPlan } from '../../../../types/plan'
import { updatePlan, fetchPlans } from '../../../../store/plans/actions'
import { Edit } from './Edit'
import { IEditDispatchProps, IEditStateProps } from './types'
import { IState } from '../../../../store/types'
import { fetchDrugs } from '../../../../store/drugs/actions'

const mapStateToProps = (state: IState): IEditStateProps => {
  return {
    plans: state.plans,
    drugs: state.drugs
  }
}

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, AnyAction>): IEditDispatchProps => {
  return {
    fetchDrugs: () => {
      return dispatch(fetchDrugs())
    },
    fetchPlans: () => {
      return dispatch(fetchPlans())
    },
    updatePlan: (plan: IChangedPlan) => {
      return dispatch(updatePlan(plan))
    }
  }
}

const EditContainer = connect(mapStateToProps, mapDispatchToProps)(Edit)

export {
  EditContainer
}
